import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { ProductCollectionStateComponent } from '../branch/product-collection-state/product-collection-state.component';
import { GiftcardsBasketModule } from '../module/giftcards/giftcards-basket.module';
import { ProductDeliveryStateComponent } from '../product-delivery-state/product-delivery-state.component';
import { SharedModule } from '../shared.module';
import { BasketAddNoticeComponent } from './add-notice/basket-add-notice.component';
import { BasketFreeDeliveryNoticeComponent } from './free-shipping/basket-free-shipping.component';
import { BasketItemQtyComponent } from './item-qty/basket-item-qty.component';
import { MinibasketComponent } from './minibasket/minibasket.component';
import { BasketViewCmsComponent } from './view/basket-view-cms.component';
import { BasketViewComponent } from './view/basket-view.component';
import { BasketViewCouponFormComponent } from './view/coupon-form/basket-view-coupon-form.component';
import { BasketViewItemComponent } from './view/item/basket-view-item.component';
import { BasketViewPaywithComponent } from './view/paywith/basket-view-paywith.component';
import { BasketViewSubmitComponent } from './view/submit/basket-view-submit.component';
import { BasketViewTotalsComponent } from './view/totals/basket-view-totals.component';
import { PaypalPayInThreeMessageComponent } from '../module/paypal/paypal-pay-in-three/paypal-pay-in-three-message.component';

@NgModule({
    imports: [SharedModule, CommonModule, GiftcardsBasketModule, ProductCollectionStateComponent, ProductDeliveryStateComponent, PaypalPayInThreeMessageComponent],
    declarations: [
        BasketAddNoticeComponent,
        BasketFreeDeliveryNoticeComponent,
        BasketItemQtyComponent,
        BasketViewSubmitComponent,
        BasketViewCmsComponent,
        BasketViewComponent,
        BasketViewCouponFormComponent,
        BasketViewItemComponent,
        BasketViewPaywithComponent,
        BasketViewSubmitComponent,
        BasketViewTotalsComponent,
        MinibasketComponent
    ],
    exports: [BasketViewCouponFormComponent, BasketViewItemComponent, BasketViewTotalsComponent]
})
export class BasketModule {
    constructor() {
        surviveTreeShaking(MinibasketComponent);
        surviveTreeShaking(BasketAddNoticeComponent);
    }
}
